export default __webpack_public_path__ + "static/media/contract_template.abfebdcb.png";